import type { CSSProperties, ReactNode } from 'react';
import { parseInline, parseTextBlocks, type InlineStyle } from '@shared/richText.js';

function inlineStyle(styles: InlineStyle[]): CSSProperties {
  const css: CSSProperties = {};
  const lines: string[] = [];
  if (styles.includes('b')) css.fontWeight = 700;
  if (styles.includes('i')) css.fontStyle = 'italic';
  if (styles.includes('u')) lines.push('underline');
  if (styles.includes('o')) lines.push('overline');
  if (styles.includes('s')) lines.push('line-through');
  if (lines.length > 0) css.textDecorationLine = lines.join(' ');
  return css;
}

function renderInline(text: string): ReactNode {
  return parseInline(text).map((run, i) =>
    run.styles.length === 0 ? (
      run.text
    ) : (
      <span key={i} style={inlineStyle(run.styles)}>
        {run.text}
      </span>
    ),
  );
}

/**
 * טקסט משימה מעוצב: שורות רגילות כפסקאות, שורות שמתחילות בסימן בולט כרשימה,
 * ועיצוב בתוך שורה (מודגש/נטוי/קו תחתון/קו חוצה/קו מעל) — ראו shared/src/richText.ts.
 */
export function FormattedText({ text }: { text: string | null | undefined }) {
  return (
    <>
      {parseTextBlocks(text).map((block, i) =>
        block.type === 'ul' ? (
          <ul key={i} className="mission-content__list">
            {block.items.map((item, j) => (
              <li key={j}>{renderInline(item)}</li>
            ))}
          </ul>
        ) : (
          <p key={i} className="mission-content__paragraph">
            {renderInline(block.text)}
          </p>
        ),
      )}
    </>
  );
}
